import GameBaseState from "./GameBaseState";
import Logger from "@js/logger";
import * as Accounts from "@js/account";
import { IStateType } from "./IGameState";
import { yunpb } from "@/types/protobuf";
import { useLayoutDataStore } from "@/store/layoutData";
import { useloginStore } from "@/store/login";
import { Modal } from "ant-design-vue";
import { isSupportPlay } from "@/js/utils";
export default class GameStateFree extends GameBaseState {
  private myType = IStateType.FREE;
  constructor() {
    super();
  }
  onPageReload() {
    Logger.log(`GameState ${IStateType[this.myType]} onPageReload`);
    this.playGameStore.resetModalState();
    this.playGameStore.isQueueing = false;
    Accounts.setCurrentGame(null);
  }
  // 开启游戏验证游游戏环境
  async playGame(game?: yunpb.IGetGameRoomInfoRsp | null) {
    Logger.log(`GameState FREE playGame`);
    await this.checkCanPlayGame(game);
    await this.handleEnterInQueue();
  }
  checkCanPlayGame(game?: yunpb.IGetGameRoomInfoRsp | null) {
    if (!game) {
      this.playGameStore.resetModalState();
      this.showToastMessage("Missing game parameters");
      return;
    }
    Logger.log(`GameState Free checkCanPlayGame`);
    const layoutDataStore = useLayoutDataStore();
    const loginStore = useloginStore();
    // 没网
    if (!navigator.onLine) {
      Modal.confirm({
        title: "Tips",
        content:
          "There is something wrong with the network. Please check it and try again.",
        okText: "OK",
        cancelText: "Have a stroll",
        centered: true,
        onOk: () => {
          console.log("好的");
        },
      });
      return;
    }
    // 验证用户所用浏览器
    if (!isSupportPlay) {
      layoutDataStore.downlaodBrowserModal = true;
      return;
    }
    // 用户是否登录，没有登陆则弹出登录框
    if (!Accounts.isLogin()) {
      loginStore.isShow = true;
      return;
    }
    Accounts.setSelectGame(game as yunpb.IGameNode);
  }
  // 开始进入排队
  async handleEnterInQueue() {
    Logger.log(`GameState Free handleEnterInQueue`);
    const game: yunpb.IGetGameRoomInfoRsp = Accounts.getSelectGame();
    const obj = await this.getOper(game);
    Logger.log(obj + "playerOper");
    if (obj) {
      if (
        obj.playerOper === this.PLAYERSTATUS.IN_QUE ||
        obj.playerOper === this.PLAYERSTATUS.NO_OPER
      ) {
        this.setState(IStateType.IN_QUE);
      }
    }
  }
}
